// 场景缩略图抓取注册表：SceneCanvas（Canvas 内部）注册实现，SceneToolbar（外部）触发调用
// 解决 Canvas 外无法使用 useThree 的问题：内部拿 gl/scene/camera → render 一帧 → toDataURL

type CaptureFn = () => string | null;

export const sceneThumbnailRegistry: {
  capture: CaptureFn | null;
} = {
  capture: null,
};